/** Issued RFIs for the "Coming up" list. The caller passes a workspace only for
 *  roles that may open the RFI Register. Any failure just means no rows.
 *  Refetches when the date changes so a response date passing appears on a
 *  dashboard left open overnight. */

import { useEffect, useMemo, useState } from 'react';
import type { RfiRecord } from '../../types/rfis';
import { useBackgroundRead } from '../../hooks/useBackgroundRead';
import { issuedRfisRead, localDayKey } from './homeComingUpReads';

const DAY_CHECK_MS = 5 * 60_000;
const NONE: readonly RfiRecord[] = [];

export function useIssuedRfis(workspaceId: string | undefined): readonly RfiRecord[] {
  const [dayKey, setDayKey] = useState(localDayKey);

  useEffect(() => {
    const id = window.setInterval(() => setDayKey(localDayKey()), DAY_CHECK_MS);
    return () => window.clearInterval(id);
  }, []);

  const read = useMemo(() => (workspaceId ? issuedRfisRead() : null), [workspaceId]);
  return useBackgroundRead(workspaceId, read, { refreshKey: dayKey }) ?? NONE;
}
